import { Navigate, useNavigate, useParams } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { Loader } from '@quero-delivery/quero-components-web';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Message } from 'semantic-ui-react';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import useMotoboy from '@/hooks/motoboy/useMotoboy';
import { Form } from './components/form';
import { DELIVERYMAN_NOT_FOUND_TOAST } from '@/_features/motoboys/constants';

function DeliverymanFormMain() {
  const navigate = useNavigate();
  const { motoboyId } = useParams<{ motoboyId: string }>();

  const {
    errorsMotoboy,
    loadingMotoboy,
    motoboy,
    createMotoboyState,
    editMotoboyState,
  } = useMotoboy(motoboyId || '');

  const errorsRequest = [
    ...createMotoboyState.errors,
    ...editMotoboyState.errors,
  ];

  useEffect(() => {
    if (!isEmpty(errorsRequest)) {
      window.scrollTo({ top: 0 });
    }
  }, [errorsRequest]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  if (!motoboy && !isEmpty(errorsMotoboy)) {
    toast.warn(DELIVERYMAN_NOT_FOUND_TOAST.message, {
      toastId: DELIVERYMAN_NOT_FOUND_TOAST.toastId,
    });
    return <Navigate to="/entregadores" />;
  }

  if (loadingMotoboy || (!motoboy && !isEmpty(motoboyId))) {
    return (
      <div className="loading-container">
        <Loader />
      </div>
    );
  }

  return (
    <div>
      <div className="register-subtitle">
        <div className="subtitle-icon" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faChevronLeft} size="lg" />
          <strong style={{ marginLeft: '0.5rem' }}>
            {motoboyId ? 'Editar' : 'Novo'} entregador
          </strong>
        </div>
      </div>
      {errorsRequest.length > 0 && <Message error list={errorsRequest} />}

      <Form />
    </div>
  );
}

export { DeliverymanFormMain };
